import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { SubsidiaryService } from '../../services/subsidiary.service';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'app-update-supplier',
    templateUrl: './update-supplier.component.html',
    styleUrls: ['./update-supplier.component.css', '../../app.component.css']
})

export class UpdateSupplierComponent implements OnInit, OnDestroy {

    supplierForm: FormGroup;
    supplier: any = [];

    subsidiaries = {};
    subsidiaryInit: any;
    subsidiaryText = '';

    id: string;

    subs: Subscription[] = [];
    underSub: Subscription;

    constructor(private formBuilder: FormBuilder,
                private router: Router,
                private activatedRoute: ActivatedRoute,
                private customerSupplierService: CustomerSupplierService,
                private subsidiaryService: SubsidiaryService) {
        this.loadSubsidiaries();
        this.id = activatedRoute.snapshot.paramMap.get('id');
        this.subs[0] = this.customerSupplierService.getCustomerSupplier(this.id).subscribe(supplierObj => {
            this.supplier = supplierObj;

            this.underSub = this.subsidiaryService.getSubsidiary(this.supplier.subsidiaryId).subscribe(subsidiaryObj => {
                this.subsidiaryText = subsidiaryObj.name;
                this.underSub.unsubscribe();
            });
            this.subs[0].unsubscribe();
        });
        this.loadSubsidiaries();
    }

    ngOnInit() {
        this.supplierForm = this.formBuilder.group({
            name: ['', Validators.required],
            description: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            subsidiary: ['', Validators.required]
        });
    }
    ngOnDestroy(){
        this.subs[1].unsubscribe();
    }

    onSubmitSupplier() {
        this.supplier = this.saveSupplier();

        this.customerSupplierService.putCustomerSupplier(this.supplier, this.id);
    }

    saveSupplier() {
        const supplierJson = {
            description: this.supplierForm.get('description').value,
            email: this.supplierForm.get('email').value,
            name: this.supplierForm.get('name').value,
            subsidiaryId: this.subsidiaries[this.supplierForm.get('subsidiary').value],
            typeId: '3',
            updatedAt: new Date()
        };

        return supplierJson;
    }

    loadSubsidiaries() {
        this.subs[1] = this.subsidiaryService.getSubsidiaries().subscribe(tempSubsidiaries => {
            const data = {};

            for (const idx in tempSubsidiaries) {
                data[tempSubsidiaries[idx].name] = null;

                this.subsidiaries[tempSubsidiaries[idx].name] = tempSubsidiaries[idx].id$;
            }

            this.subsidiaryInit = {
                'data': data,
                onAutocomplete: (val) => {
                    // console.log(val);
                    // console.log(this.subsidiaries[val]);
                }
            };
        });
    }

    onBlurSubsidiary() {
        if (this.subsidiaries[this.subsidiaryText] === undefined) {
            this.subsidiaryText = '';
        }
    }

}
